import { Card, Grid, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fShortenNumber } from '../../../utils/formatNumber'
import Iconify from '../../../components/Iconify'
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import InfoCard from '../../../components/batch/InfoCard';
import SyncLoader from "react-spinners/SyncLoader";
import { useTheme } from '@emotion/react';
const StudentBatches = () => {

    const theme = useTheme();

    const navigate = useNavigate()
    const [batchInfo, setBatchInfo] = useState()
    const [loading, setLoading] = React.useState(true);




    //BatchesDetails
    useEffect(() => {
        const token = localStorage.getItem("token");
        async function fetchUsers() {
            const fullResponse = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminPanel/getBatchesDetails`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });
            const responseJson = await fullResponse.json();
            //console.log(responseJson.data);
            setBatchInfo(responseJson.data);
            setLoading(false)
        }
        fetchUsers()
    }, [])
    //console.log(batchInfo)
    return (<>
        {loading ? (

            <Stack justifyContent='center' alignItems='center' sx={{ height: '100%' }}> <SyncLoader color={theme.palette.primary.mainTheme} loading={loading} size={20} /></Stack>) : (<>
                <Typography variant='h3' mb={5} ml={3}>Courses Purchases</Typography>
                <Grid container pl={5} pr={3} spacing={4}>

                    {batchInfo?.map((item, i) => {

                        const { _id, is_active } = item;

                        return <Grid item key={i} xs={12} sm={6} md={4} sx={{ cursor: 'pointer' }} onClick={() => navigate(`/dashboard/studentBatches/studentList/${is_active ? '1' : '0'}/${_id}`)}>
                            <InfoCard data={item} title="Info" path="" use="Student Batches" />

                        </Grid>
                    })}
                </Grid>
            </>)}
    </>
    )
}

export default StudentBatches